import { useMutation, useQuery, useQueryClient } from 'react-query'
import { ComissoesOrcamentoService } from '../service/comissoes-orcamento-service'
import { useToast } from '@chakra-ui/react'

const comissoesOrcamentoService = new ComissoesOrcamentoService()

export const useComissoesOrcamento = ({ numeroNota, enabled }) => {
    return useQuery(['comissoesOrcamento', numeroNota], () => comissoesOrcamentoService.getComissoesOrcamento(numeroNota), {
        enabled: enabled,
        refetchOnWindowFocus: false,
        // staleTime: 1000 * 60 * 5,
        suspense: true,
    })
}

export const useUpdateComissaoOrcamento = () => {
    const queryClient = useQueryClient()
    const toast = useToast({
        position: 'top-right',
        duration: 5000,
        isClosable: true,
    })

    return useMutation({
        mutationFn: (data) => comissoesOrcamentoService.updateComissoes(data),
        onError: (err, variables, previousData) => queryClient.setQueryData('comissoesOrcamento', variables.numero_nota, previousData),
        onSuccess: (data) => {
            queryClient.invalidateQueries('comissoesOrcamento', data.numero_nota)
            toast({
                title: 'Comissões atualizadas com sucesso',
                status: 'success',
            })
        },
        onSettled: (data) => queryClient.invalidateQueries('comissoesOrcamento', data.numero_nota),
    })
}
